"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cache = exports.NO_CACHE = void 0;
const lru_cache_1 = __importDefault(require("lru-cache"));
exports.NO_CACHE = Symbol('NO_CACHE');
class Cache {
    constructor() {
        this.dsMap = new lru_cache_1.default(50);
    }
    // private stringifyKey(options: ICellValueKeyOptions) {
    //   const { dsId, fieldId, recordId } = options;
    //   return `${dsId}-${fieldId}-${recordId}`;
    // }
    // private parseKey(key: string) {
    //   const ids = key.split('-');
    //   return {
    //     dsId: ids[0],
    //     fieldId: ids[1],
    //     recordId: ids[2]
    //   };
    // }
    getDsCache(dsId) {
        return this.dsMap.get(dsId);
    }
    getDsFields(dsId) {
        const ds = this.getDsCache(dsId);
        if (!ds) {
            return null;
        }
        const fields = [];
        for (const [key] of ds.cellValues) {
            fields.push(key);
        }
        return fields;
    }
    addCellCache(dsId, fieldId, recordId, value) {
        // Check if the table cache exists
        let dsCache = this.getDsCache(dsId);
        if (!dsCache) {
            dsCache = {
                cellValues: new Map(),
            };
            this.dsMap.set(dsId, dsCache);
        }
        // Check if the column cache exists
        let fieldCache = dsCache.cellValues.get(fieldId);
        if (!fieldCache) {
            fieldCache = new Map();
            dsCache.cellValues.set(fieldId, fieldCache);
        }
        fieldCache.set(recordId, value);
    }
    removeCellCache(dsId, fieldId, recordId) {
        const ds = this.getDsCache(dsId);
        if (!ds) {
            return false;
        }
        if (!recordId) {
            ds.cellValues.delete(fieldId);
            return true;
        }
        const field = ds.cellValues.get(fieldId);
        if (!field) {
            return false;
        }
        return field.delete(recordId);
    }
    removeCellCacheByRecord(dsId, recordId) {
        const fields = this.getDsFields(dsId);
        if (!fields) {
            return false;
        }
        return fields.every((fieldId) => {
            return this.removeCellCache(dsId, fieldId, recordId);
        });
    }
    removeDsCache(dsId) {
        this.dsMap.set(dsId, null);
    }
    getCellCache(dsId, fieldId, recordId) {
        const ds = this.getDsCache(dsId);
        if (!ds) {
            return exports.NO_CACHE;
        }
        const field = ds.cellValues.get(fieldId);
        if (!field) {
            return exports.NO_CACHE;
        }
        return field.get(recordId) || exports.NO_CACHE;
    }
    clearCache() {
        this.dsMap.reset();
    }
}
exports.cache = new Cache();
//# sourceMappingURL=cache.js.map